class MenuHeader extends HTMLElement {
  constructor(){
    super();

    this.querySelector('#menu-mobile-button').addEventListener("click", b => {
      this.querySelector("#menu-mobile").classList.toggle("hidden");
      this.querySelector("#menu-mobile").classList.toggle("absolute");
    })

    this.querySelector('#menu-mobile-close').addEventListener("click", b => {
      this.querySelector("#menu-mobile").classList.toggle("hidden");
      this.querySelector("#menu-mobile").classList.toggle("absolute");
    })

    this.querySelector('#menu-mobile-nav').querySelectorAll('button').forEach(btn => {
      btn.addEventListener("click", () => {
        btn.nextElementSibling.classList.toggle("hidden");
      });
    });

  }
}

customElements.define('menu-header', MenuHeader);